import React from "react";
import "../styles/hero.css";
import { FaFacebookF, FaInstagram } from "react-icons/fa";

export default function Hero() {
  return (
    <section className="ph-hero" id="home" aria-label="Pizza Home – hero">
      <div className="container">
        <div className="row align-items-center g-4">
          {/* Left: text */}
          <div className="col-lg-7 order-2 order-lg-1">
            <h1 className="ph-hero-title">
              <span className="ph-accent">Pizza Home Debrecen</span> – Vékony
              tésztás pizzák, gyros tálak és óriáspalacsinták házhoz
            </h1>

            {/* Opening Soon Badge */}
            <div className="ph-opening-soon">
              <strong>Hamarosan megnyitunk Debrecenben!</strong>
            </div>

            <p className="ph-hero-sub">
              Debrecen területén a házhozszállítás ingyenes.
            </p>

            <p className="ph-hero-desc">
              A legfinomabb pizzák Debrecenben csak rád várnak! Ha a ropogós,
              vékony tésztás pizzák mellett inkább egy bőséges gyros tálat
              választanál, abban is otthon vagyunk, desszertnek pedig
              válogathatsz óriáspalacsintáink közül.
            </p>

            <p className="ph-hero-desc">
              A legjobban akkor jársz, ha közvetlenül a{" "}
              <a
                href="https://debrecenipizza.hu/"
                aria-label="Rendelés a Pizza Home Debrecen saját felületén"
              >
                saját rendelési felületünkön
              </a>{" "}
              adod le a rendelést.
            </p>

            <a href="https://debrecenipizza.hu/" className="btn btn-hero mt-3">
              Megnézem az étlapot
            </a>
          </div>

          {/* Right: image + social */}
          <div className="col-lg-5 text-center order-1 order-lg-2 mt-0">
            <div className="ph-hero-imgwrap mb-lg-5">
              <picture>
                <source srcSet="/images/hero.webp" type="image/webp" />
                <img
                  src="/images/hero.webp"
                  alt="Frissen sült pizza tálalva"
                  className="ph-hero-img"
                  loading="eager"
                  decoding="async"
                  width="1200"
                  height="630"
                />
              </picture>
            </div>

            {/* Social bar under image */}
            <div className="ph-social">
              <a
                href="https://www.instagram.com/pizzahomedebrecen/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
                <span>Instagram</span>
              </a>

              <a
                href="https://www.facebook.com/pizzahomedebrecen"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
                <span>Facebook</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
